<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import LocaLogo from "@/assets/general/loca-logo-horizontal.png";
  import FinaLogo from "@/assets/general/fina-logo.png";

  const dispatch = createEventDispatcher();

  export let isOpen = false;
  let isAgreed: boolean = false;

  // Handle submit action
  function handleSubmit() {
    if (isAgreed) {
      dispatch("agree");
      closeModal();
    }
  }

  function closeModal() {
    isAgreed = false;
    dispatch("close");
  }
</script>

{#if isOpen}
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <!-- svelte-ignore a11y-no-static-element-interactions -->
  <div
    class="fixed inset-0 z-50 flex items-end justify-center bg-black bg-opacity-50 animate-fade-in"
    on:click|self={closeModal}
  >
    <div
      class="flex w-full h-full flex-col items-center bg-white font-sans relative animate-slide-up"
    >
      <div
        class="sticky top-0 bg-white z-10 px-6 py-5 border-b border-gray-200 w-full"
      >
        <div class="flex items-center">
          <!-- Left spacer -->
          <div class="w-10"></div>

          <!-- Title -->
          <h2 class="flex-1 text-xl font-semibold text-gray-900 text-center">
            Fina loan
          </h2>

          <!-- Close button -->
          <button
            type="button"
            on:click={closeModal}
            class="btn btn-ghost btn-sm btn-circle w-10 h-10"
            aria-label="Close"
          >
            <svg
              class="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
      </div>
      <div class="p-4 flex flex-col items-center overflow-y-auto pb-28">
        <div class="mb-10 flex h-20 items-center justify-center gap-5">
          <img
            src={LocaLogo}
            alt="Loca Logo"
            class="w-[134px] object-contain"
          />

          <div class="h-12 w-[1.5px] bg-blue-900"></div>

          <img
            src={FinaLogo}
            alt="FINA Logo"
            class="w-[131px] object-contain"
          />
        </div>

        <h1 class="mb-6 text-2xl font-bold text-gray-900">ຄຳແນະນຳ</h1>

        <div
          class="mb-8 flex-1 text-justify text-[15px] leading-relaxed text-gray-700"
        >
          <p class="mb-2">
            &nbsp;&nbsp;  ທ່ານກຳລັງເຂົ້າສູ່ບໍລິການ ຂໍສິນເຊື່ອ FINA ຜ່ານແອັບ LOCA ເຊິ່ງໃຫ້ບໍລິການໂດຍ ສະຖາບັນການເງິນຈຸລະພາກ FINA.
          </p>

          <p class="mb-2">
            &nbsp;&nbsp;  ໃນຂະບວນການຂໍສິນເຊື່ອ ຂໍ້ມູນທີ່ຈຳເປັນຂອງທ່ານຈະຖືກນຳສົ່ງໄປຍັງ FINA ເພື່ອກວດສອບ, ພິຈາລະນາ ແລະ ດຳເນີນຕາມຂັ້ນຕອນການຂໍສິນເຊື່ອຕໍ່ໄປ.
          </p>

          <p class="mb-2">
            &nbsp;&nbsp; ການອະນຸມັດ ຫຼື ປະຕິເສດຄຳຂໍສິນເຊື່ອ ຈະເປັນໄປຕາມຫຼັກເກນ ແລະ ນະໂຍບາຍການພິຈາລະນາຂອງ FINA.
          </p>
        </div>

        <div class="mb-5 w-full px-2">
          <label class="flex items-start gap-3 cursor-pointer">
            <div class="relative flex items-center justify-center mt-1">
              <input
                type="checkbox"
                class="custom-checkbox"
                bind:checked={isAgreed}
              />
              <div class="checkbox-box">
                {#if isAgreed}
                  <svg class="checkmark" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M20 6L9 17L4 12"
                      stroke="white"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                {/if}
              </div>
            </div>
            <span class="flex-1 leading-relaxed text-gray-700">
              ຂ້ອຍເຂົ້າໃຈ ແລະ ຍອມຮັບເງື່ອນໄຂ
            </span>
          </label>
        </div>

        <button
          on:click={handleSubmit}
          disabled={!isAgreed}
          class={`absolute bottom-10 w-[95%] rounded-2xl py-3.5 text-lg font-medium text-white shadow-md transition-all duration-200
            ${
              isAgreed
                ? "bg-blue-primary active:scale-[0.98]"
                : "cursor-not-allowed bg-gray-300"
            }`}
        >
          ເຂົ້າສູ່ບໍລິການສິນເຊື່ອ
        </button>
      </div>
    </div>
  </div>
{/if}

<style>
  @keyframes fade-in {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes slide-up {
    from {
      transform: translateY(100%);
    }
    to {
      transform: translateY(0);
    }
  }

  .animate-fade-in {
    animation: fade-in 0.3s ease-out;
  }

  .animate-slide-up {
    animation: slide-up 0.3s ease-out;
  }

  /* Custom Checkbox Styles */
  .custom-checkbox {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
  }

  .checkbox-box {
    width: 22px;
    height: 22px;
    border: 2px solid #d1d5db;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    background-color: white;
  }

  .custom-checkbox:checked ~ .checkbox-box {
    background-color: #1d4ed8;
    border-color: #1d4ed8;
  }

  .custom-checkbox:checked ~ .checkbox-box .checkmark {
    animation: checkmark-pop 0.3s ease-out;
  }

  .checkmark {
    width: 18px;
    height: 18px;
  }

  @keyframes checkmark-pop {
    0% {
      transform: scale(0);
    }
    50% {
      transform: scale(1.2);
    }
    100% {
      transform: scale(1);
    }
  }

  label:hover .checkbox-box {
    border-color: #9ca3af;
  }

  .custom-checkbox:checked ~ .checkbox-box:hover {
    border-color: #1d4ed8;
  }
</style>
